<template>
  <div class="input">
    <div class="input-label">銀行名</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="name">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    name: {
      get: function () {
        return this.$store.state.bank.name
      },
      set: function (value) {
        this.$store.commit(
          'bank/setName',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss'
</style>
